import { Tooltip as TooltipElement } from '@dixa/lib-shared-habla';
import { createElement, useCallback, useMemo, useState, } from 'react';
export function useTooltip() {
    const [tooltipState, setTooltipState] = useState(null);
    const onTooltipShow = useCallback(setTooltipState, [setTooltipState]);
    const onTooltipHide = useCallback(() => {
        setTooltipState(null);
    }, [setTooltipState]);
    const tooltip = useMemo(() => tooltipState
        ? createElement(TooltipElement, {
            wrap: 'none',
            head: tooltipState.head,
            content: tooltipState.content,
            alwaysShow: true,
        }, createElement('div', {
            style: {
                position: 'absolute',
                top: tooltipState.position.y,
                left: tooltipState.position.x,
            },
        }))
        : null, [tooltipState]);
    return {
        tooltip,
        onTooltipShow,
        onTooltipHide,
    };
}
